/*
 * @Author: Tahiti
 * @Date: 2025-10-28 18:00:00
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-10-28 18:00:00
 * @Description: About Us 页面多语言配置
 * @FilePath: /weryai-web/locales/modules/aboutUs.ts
 */
export default {
    zh: {
        // 页面标题
        pageTitle: '关于 微鲤AI',
        
        // Hero 部分
        subtitle: 'AI 视频、图像与角色生成的先行者',
        description: '微鲤AI 是新一代多模态内容创作平台。无论是令人惊艳的图像与视频、充满个性的动态角色，还是实现天马行空创意的无限画布，微鲤AI 都能为您开启由 AI 驱动的无限创作可能。',
        
        // 平台部分
        platformTitle: '一个平台，无限可能',
        platformDescription: '告别频繁切换不同工具。微鲤AI 为您提供无缝衔接的 AI 图像、视频生成器，先进的模型与工具，让您轻松创造震撼视觉效果，释放极致创意。',
        
        // 为什么选择我们
        whyChooseTitle: '为什么选择 微鲤AI？',
        
        // 功能卡片
        professionalTeamTitle: '专业团队',
        professionalTeamDesc: '由一支具备 AI 技术与多媒体制作经验的多元化团队创立，微鲤AI 致力于为您的创意之旅提供行业领先的专业体验。',
        
        innovativeTechTitle: '创新技术',
        innovativeTechDesc: '融合最新的 AI 技术突破，支持包括 Veo 3.1、Sora 2、Nano Banana、FLUX 等在内的多模型无缝接入，让您轻松生成高质量的视频、图像等内容。',
        
        userCentricTitle: '以用户为核心',
        userCentricDesc: '平台以用户体验为中心，提供直观易用的界面与无限画布，助您尽情探索无限创作空间。同时，我们的专属支持团队始终随时为您提供帮助。',
        
        // CTA 部分
        ctaTitle: '加入 1000 多万用户，使用 微鲤AI 创造和启发灵感',
        ctaButton: '立即开启体验',
    },
    en: {
        // Page title
        pageTitle: 'About 微鲤AI',
        
        // Hero section
        subtitle: 'Pioneer in AI Video, Image & Digital Human Generation',
        description: '微鲤AI is a next-generation multimodal content creation platform. Whether it\'s stunning images and videos, dynamic digital humans with personality, or infinite canvases to realize wild ideas, 微鲤AI unlocks unlimited creative possibilities powered by AI.',
        
        // Platform section
        platformTitle: 'One Platform, Infinite Possibilities',
        platformDescription: 'Say goodbye to frequent tool switching. 微鲤AI provides seamlessly integrated AI image and video generators, advanced models and tools, allowing you to easily create stunning visual effects and unleash ultimate creativity.',
        
        // Why choose us
        whyChooseTitle: 'Why Choose 微鲤AI?',
        
        // Feature cards
        professionalTeamTitle: 'Professional Team',
        professionalTeamDesc: 'Founded by a diverse team with AI technology and multimedia production experience, 微鲤AI is committed to providing industry-leading professional experiences for your creative journey.',
        
        innovativeTechTitle: 'Innovative Technology',
        innovativeTechDesc: 'Integrating the latest AI technology breakthroughs, supporting seamless access to multiple models including Veo 3.1, Sora 2, Nano Banana, FLUX, and more, allowing you to easily generate high-quality videos, images, and other content.',
        
        userCentricTitle: 'User-Centric',
        userCentricDesc: 'The platform centers on user experience, providing an intuitive and easy-to-use interface with infinite canvas, helping you explore unlimited creative space. Meanwhile, our dedicated support team is always ready to assist you.',
        
        // CTA section
        ctaTitle: 'Join 10+ Million Users Creating and Inspiring with 微鲤AI',
        ctaButton: 'Start Creating Now',
    },
    ja: {
        // ページタイトル
        pageTitle: '微鲤AI について',
        
        // Hero セクション
        subtitle: 'AI ビデオ、画像、デジタルヒューマン生成のパイオニア',
        description: '微鲤AI は次世代のマルチモーダルコンテンツ制作プラットフォームです。素晴らしい画像やビデオ、個性豊かな動的デジタルヒューマン、無限のキャンバスで奇想天外なアイデアを実現するなど、微鲤AI は AI によって無限の創造的可能性を解き放ちます。',
        
        // プラットフォームセクション
        platformTitle: '一つのプラットフォーム、無限の可能性',
        platformDescription: '頻繁なツールの切り替えにさようなら。微鲤AI は、シームレスに統合された AI 画像・ビデオジェネレーター、高度なモデルとツールを提供し、驚くべき視覚効果を簡単に作成し、究極の創造性を解き放つことができます。',
        
        // なぜ私たちを選ぶ
        whyChooseTitle: 'なぜ 微鲤AI を選ぶのか？',
        
        // 機能カード
        professionalTeamTitle: 'プロフェッショナルチーム',
        professionalTeamDesc: 'AI 技術とマルチメディア制作の経験を持つ多様なチームによって設立された 微鲤AI は、あなたのクリエイティブな旅に業界をリードするプロフェッショナルな体験を提供することに専念しています。',
        
        innovativeTechTitle: '革新的技術',
        innovativeTechDesc: '最新の AI 技術の突破を統合し、Veo 3.1、Sora 2、Nano Banana、FLUX などを含む複数のモデルへのシームレスなアクセスをサポートし、高品質のビデオ、画像などのコンテンツを簡単に生成できます。',
        
        userCentricTitle: 'ユーザー中心',
        userCentricDesc: 'プラットフォームはユーザーエクスペリエンスを中心に、直感的で使いやすいインターフェースと無限のキャンバスを提供し、無限の創造的空間を探索するのをサポートします。また、専任のサポートチームがいつでもお手伝いします。',
        
        // CTA セクション
        ctaTitle: '1000 万人以上のユーザーが 微鲤AI で創造とインスピレーションを得ています',
        ctaButton: '今すぐ始める',
    },
    ko: {
        // 페이지 제목
        pageTitle: '微鲤AI 소개',
        
        // Hero 섹션
        subtitle: 'AI 비디오, 이미지 및 디지털 휴먼 생성의 선구자',
        description: 'WeryAI는 차세대 멀티모달 콘텐츠 제작 플랫폼입니다. 놀라운 이미지와 비디오, 개성 있는 동적 디지털 휴먼, 무한한 캔버스로 기발한 아이디어를 실현하든, WeryAI는 AI로 구동되는 무한한 창의적 가능성을 열어줍니다。',
        
        // 플랫폼 섹션
        platformTitle: '하나의 플랫폼, 무한한 가능성',
        platformDescription: '잦은 도구 전환에 작별하세요. WeryAI는 원활하게 통합된 AI 이미지 및 비디오 생성기, 고급 모델 및 도구를 제공하여 놀라운 시각 효과를 쉽게 만들고 궁극의 창의성을 발휘할 수 있습니다。',
        
        // 우리를 선택하는 이유
        whyChooseTitle: 'WeryAI를 선택하는 이유는?',
        
        // 기능 카드
        professionalTeamTitle: '전문 팀',
        professionalTeamDesc: 'AI 기술 및 멀티미디어 제작 경험을 가진 다양한 팀이 설립한 WeryAI는 여러분의 창의적인 여정에 업계를 선도하는 전문적인 경험을 제공하는 데 전념하고 있습니다。',
        
        innovativeTechTitle: '혁신적인 기술',
        innovativeTechDesc: '최신 AI 기술 혁신을 통합하여 Veo 3.1, Sora 2, Nano Banana, FLUX 등을 포함한 여러 모델에 원활하게 액세스하여 고품질 비디오, 이미지 및 기타 콘텐츠를 쉽게 생성할 수 있습니다。',
        
        userCentricTitle: '사용자 중심',
        userCentricDesc: '플랫폼은 사용자 경험을 중심으로 직관적이고 사용하기 쉬운 인터페이스와 무한한 캔버스를 제공하여 무한한 창의적 공간을 탐색하는 데 도움을 줍니다. 또한 전담 지원 팀이 항상 도와드릴 준비가 되어 있습니다。',
        
        // CTA 섹션
        ctaTitle: 'WeryAI로 창조하고 영감을 얻는 1000만 명 이상의 사용자에 합류하세요',
        ctaButton: '지금 시작하기',
    },
    tw: {
        // 頁面標題
        pageTitle: '關於 微鲤AI',

        // Hero 區塊
        subtitle: 'AI 影片、圖像與角色生成的先行者',
        description:
            '微鲤AI 是新一代多模態內容創作平台。無論是令人驚豔的圖像與影片、充滿個性的動態角色，或是實現天馬行空創意的無限畫布，微鲤AI 都能為您開啟由 AI 驅動的無限創作可能。',

        // 平台區塊
        platformTitle: '一個平台，無限可能',
        platformDescription:
            '告別頻繁切換不同工具。微鲤AI 提供無縫銜接的 AI 圖像、影片生成器與先進模型工具，讓您輕鬆創造震撼視覺效果，釋放極致創意。',

        // 為什麼選擇我們
        whyChooseTitle: '為什麼選擇 微鲤AI？',

        // 功能卡片
        professionalTeamTitle: '專業團隊',
        professionalTeamDesc:
            '由具備 AI 技術與多媒體製作經驗的多元團隊創立，微鲤AI 致力於為您的創作之旅提供業界領先的專業體驗。',

        innovativeTechTitle: '創新技術',
        innovativeTechDesc:
            '融合最新 AI 技術突破，支援 Veo 3.1、Sora 2、Nano Banana、FLUX 等多模型無縫接入，讓您輕鬆生成高品質影片與圖像等內容。',

        userCentricTitle: '以使用者為核心',
        userCentricDesc:
            '平台以使用者體驗為核心，提供直觀易用的介面與無限畫布，協助您探索無限創作空間。我們的專屬支援團隊也隨時準備協助您。',

        // CTA 區塊
        ctaTitle: '加入 1000 萬以上用戶，與 微鲤AI 一起創作與啟發靈感',
        ctaButton: '立即開始創作',
    },
    pl: {
        // Page title
        pageTitle: 'O 微鲤AI',

        // Hero section
        subtitle: 'Pionier w generowaniu wideo, obrazów i postaci AI',
        description:
            '微鲤AI to nowej generacji platforma tworzenia treści multimodalnych. Od zachwycających obrazów i wideo, przez dynamiczne postacie AI, po nieskończone płótno do realizacji śmiałych pomysłów — 微鲤AI otwiera nieograniczone możliwości kreatywne.',

        // Platform section
        platformTitle: 'Jedna platforma, nieskończone możliwości',
        platformDescription:
            'Pożegnaj ciągłe przełączanie narzędzi. 微鲤AI łączy generatory obrazów i wideo AI, zaawansowane modele oraz narzędzia, abyś mógł łatwo tworzyć imponujące efekty wizualne.',

        // Why choose us
        whyChooseTitle: 'Dlaczego 微鲤AI?',

        // Feature cards
        professionalTeamTitle: 'Profesjonalny zespół',
        professionalTeamDesc:
            'Stworzony przez różnorodny zespół z doświadczeniem w AI i produkcji multimediów, 微鲤AI zapewnia profesjonalne doświadczenie na najwyższym poziomie.',

        innovativeTechTitle: 'Innowacyjna technologia',
        innovativeTechDesc:
            'Integrujemy najnowsze przełomy AI i zapewniamy płynny dostęp do wielu modeli, m.in. Veo 3.1, Sora 2, Nano Banana, FLUX i innych — aby generować wideo, obrazy i inne treści wysokiej jakości.',

        userCentricTitle: 'Zorientowane na użytkownika',
        userCentricDesc:
            'Platforma stawia na doświadczenie użytkownika: intuicyjny interfejs i nieskończone płótno pomagają odkrywać kreatywność. Nasz zespół wsparcia jest zawsze gotowy do pomocy.',

        // CTA section
        ctaTitle: 'Dołącz do ponad 10 milionów użytkowników tworzących z 微鲤AI',
        ctaButton: 'Zacznij tworzyć',
    },
    es: {
        // Título de página
        pageTitle: 'Acerca de 微鲤AI',
        
        // Sección Hero
        subtitle: 'Pionero en Generación de Video, Imagen y Humanos Digitales con IA',
        description: '微鲤AI es una plataforma de creación de contenido multimodal de próxima generación. Ya sean imágenes y videos impresionantes, humanos digitales dinámicos con personalidad o lienzos infinitos para realizar ideas descabelladas, 微鲤AI desbloquea posibilidades creativas ilimitadas impulsadas por IA.',
        
        // Sección de plataforma
        platformTitle: 'Una Plataforma, Posibilidades Infinitas',
        platformDescription: 'Diga adiós al cambio frecuente de herramientas. 微鲤AI proporciona generadores de imágenes y videos de IA perfectamente integrados, modelos y herramientas avanzadas, lo que le permite crear fácilmente efectos visuales impresionantes y liberar la máxima creatividad.',
        
        // Por qué elegirnos
        whyChooseTitle: '¿Por qué elegir 微鲤AI?',
        
        // Tarjetas de características
        professionalTeamTitle: 'Equipo Profesional',
        professionalTeamDesc: 'Fundada por un equipo diverso con experiencia en tecnología de IA y producción multimedia, 微鲤AI está comprometida a proporcionar experiencias profesionales líderes en la industria para su viaje creativo.',
        
        innovativeTechTitle: 'Tecnología Innovadora',
        innovativeTechDesc: 'Integrando los últimos avances en tecnología de IA, admitiendo acceso perfecto a múltiples modelos, incluidos Veo 3.1, Sora 2, Nano Banana, FLUX y más, lo que le permite generar fácilmente videos, imágenes y otro contenido de alta calidad.',
        
        userCentricTitle: 'Centrado en el Usuario',
        userCentricDesc: 'La plataforma se centra en la experiencia del usuario, proporcionando una interfaz intuitiva y fácil de usar con lienzo infinito, ayudándole a explorar un espacio creativo ilimitado. Mientras tanto, nuestro equipo de soporte dedicado siempre está listo para ayudarle.',
        
        // Sección CTA
        ctaTitle: 'Únase a más de 10 millones de usuarios que crean e inspiran con 微鲤AI',
        ctaButton: 'Comienza a Crear Ahora',
    },
    fr: {
        // Titre de page
        pageTitle: 'À propos de 微鲤AI',
        
        // Section Hero
        subtitle: 'Pionnier de la Génération de Vidéos, Images et Humains Numériques par IA',
        description: '微鲤AI est une plateforme de création de contenu multimodal de nouvelle génération. Qu\'il s\'agisse d\'images et de vidéos époustouflantes, d\'humains numériques dynamiques avec personnalité ou de toiles infinies pour réaliser des idées folles, 微鲤AI déverrouille des possibilités créatives illimitées alimentées par l\'IA.',
        
        // Section plateforme
        platformTitle: 'Une Plateforme, Possibilités Infinies',
        platformDescription: 'Dites adieu aux changements d\'outils fréquents. 微鲤AI fournit des générateurs d\'images et de vidéos IA parfaitement intégrés, des modèles et des outils avancés, vous permettant de créer facilement des effets visuels époustouflants et de libérer une créativité ultime.',
        
        // Pourquoi nous choisir
        whyChooseTitle: 'Pourquoi Choisir 微鲤AI?',
        
        // Cartes de fonctionnalités
        professionalTeamTitle: 'Équipe Professionnelle',
        professionalTeamDesc: 'Fondée par une équipe diversifiée avec une expérience en technologie IA et production multimédia, 微鲤AI s\'engage à fournir des expériences professionnelles de pointe pour votre parcours créatif.',
        
        innovativeTechTitle: 'Technologie Innovante',
        innovativeTechDesc: 'Intégrant les dernières percées en technologie IA, prenant en charge l\'accès transparent à plusieurs modèles, y compris Veo 3.1, Sora 2, Nano Banana, FLUX et plus, vous permettant de générer facilement des vidéos, des images et d\'autres contenus de haute qualité.',
        
        userCentricTitle: 'Centré sur l\'Utilisateur',
        userCentricDesc: 'La plateforme se concentre sur l\'expérience utilisateur, fournissant une interface intuitive et facile à utiliser avec une toile infinie, vous aidant à explorer un espace créatif illimité. Pendant ce temps, notre équipe de support dédiée est toujours prête à vous aider.',
        
        // Section CTA
        ctaTitle: 'Rejoignez plus de 10 millions d\'utilisateurs créant et inspirant avec 微鲤AI',
        ctaButton: 'Commencer à Créer Maintenant',
    },
    de: {
        // Seitentitel
        pageTitle: 'Über 微鲤AI',
        
        // Hero-Bereich
        subtitle: 'Pionier in der KI-Video-, Bild- und Digitalen Menschen-Generierung',
        description: '微鲤AI ist eine multimodale Content-Erstellungsplattform der nächsten Generation. Ob atemberaubende Bilder und Videos, dynamische digitale Menschen mit Persönlichkeit oder unendliche Leinwände zur Verwirklichung wilder Ideen - 微鲤AI erschließt unbegrenzte kreative Möglichkeiten, die von KI angetrieben werden.',
        
        // Plattform-Bereich
        platformTitle: 'Eine Plattform, Unendliche Möglichkeiten',
        platformDescription: 'Verabschieden Sie sich von häufigem Tool-Wechsel. 微鲤AI bietet nahtlos integrierte KI-Bild- und Video-Generatoren, fortschrittliche Modelle und Tools, mit denen Sie mühelos atemberaubende visuelle Effekte erstellen und ultimative Kreativität entfesseln können.',
        
        // Warum uns wählen
        whyChooseTitle: 'Warum 微鲤AI Wählen?',
        
        // Funktionskarten
        professionalTeamTitle: 'Professionelles Team',
        professionalTeamDesc: 'Gegründet von einem vielfältigen Team mit Erfahrung in KI-Technologie und Multimedia-Produktion, engagiert sich 微鲤AI dafür, branchenführende professionelle Erfahrungen für Ihre kreative Reise zu bieten.',
        
        innovativeTechTitle: 'Innovative Technologie',
        innovativeTechDesc: 'Integration der neuesten KI-Technologie-Durchbrüche, Unterstützung des nahtlosen Zugriffs auf mehrere Modelle, einschließlich Veo 3.1, Sora 2, Nano Banana, FLUX und mehr, sodass Sie mühelos hochwertige Videos, Bilder und andere Inhalte generieren können.',
        
        userCentricTitle: 'Benutzerzentriert',
        userCentricDesc: 'Die Plattform konzentriert sich auf die Benutzererfahrung und bietet eine intuitive und benutzerfreundliche Oberfläche mit unendlicher Leinwand, die Ihnen hilft, unbegrenzten kreativen Raum zu erkunden. Währenddessen ist unser engagiertes Support-Team immer bereit, Ihnen zu helfen.',
        
        // CTA-Bereich
        ctaTitle: 'Schließen Sie sich über 10 Millionen Benutzern an, die mit 微鲤AI kreieren und inspirieren',
        ctaButton: 'Jetzt Erstellen',
    },
    ru: {
        // Заголовок страницы
        pageTitle: 'О 微鲤AI',
        
        // Hero секция
        subtitle: 'Пионер в Генерации ИИ Видео, Изображений и Цифровых Людей',
        description: '微鲤AI — это платформа создания мультимодального контента нового поколения. Будь то потрясающие изображения и видео, динамичные цифровые люди с характером или бесконечные холсты для реализации диких идей, 微鲤AI открывает неограниченные творческие возможности, управляемые ИИ.',
        
        // Раздел платформы
        platformTitle: 'Одна Платформа, Бесконечные Возможности',
        platformDescription: 'Попрощайтесь с частой сменой инструментов. 微鲤AI предоставляет бесшовно интегрированные генераторы изображений и видео с ИИ, передовые модели и инструменты, позволяющие легко создавать потрясающие визуальные эффекты и раскрывать максимальную креативность.',
        
        // Почему выбрать нас
        whyChooseTitle: 'Почему Выбрать 微鲤AI?',
        
        // Карточки функций
        professionalTeamTitle: 'Профессиональная Команда',
        professionalTeamDesc: 'Основанная разнообразной командой с опытом в технологии ИИ и мультимедийном производстве, 微鲤AI стремится предоставлять ведущий в отрасли профессиональный опыт для вашего творческого путешествия.',
        
        innovativeTechTitle: 'Инновационная Технология',
        innovativeTechDesc: 'Интегрируя последние прорывы в технологии ИИ, поддерживая бесшовный доступ к нескольким моделям, включая Veo 3.1, Sora 2, Nano Banana, FLUX и другие, позволяя легко генерировать высококачественные видео, изображения и другой контент.',
        
        userCentricTitle: 'Ориентированность на Пользователя',
        userCentricDesc: 'Платформа сосредоточена на пользовательском опыте, предоставляя интуитивно понятный и простой в использовании интерфейс с бесконечным холстом, помогая вам исследовать неограниченное творческое пространство. В то же время наша специальная команда поддержки всегда готова помочь вам.',
        
        // Раздел CTA
        ctaTitle: 'Присоединяйтесь к более чем 10 миллионам пользователей, создающих и вдохновляющихся с 微鲤AI',
        ctaButton: 'Начать Создавать Сейчас',
    },
    pt: {
        // Título da página
        pageTitle: 'Sobre 微鲤AI',
        
        // Seção Hero
        subtitle: 'Pioneiro na Geração de Vídeo, Imagem e Humanos Digitais com IA',
        description: '微鲤AI é uma plataforma de criação de conteúdo multimodal de próxima geração. Sejam imagens e vídeos impressionantes, humanos digitais dinâmicos com personalidade ou telas infinitas para realizar ideias malucas, 微鲤AI desbloqueia possibilidades criativas ilimitadas impulsionadas por IA.',
        
        // Seção da plataforma
        platformTitle: 'Uma Plataforma, Possibilidades Infinitas',
        platformDescription: 'Diga adeus à troca frequente de ferramentas. 微鲤AI fornece geradores de imagens e vídeos de IA perfeitamente integrados, modelos e ferramentas avançadas, permitindo criar facilmente efeitos visuais impressionantes e liberar criatividade máxima.',
        
        // Por que nos escolher
        whyChooseTitle: 'Por que Escolher 微鲤AI?',
        
        // Cartões de recursos
        professionalTeamTitle: 'Equipe Profissional',
        professionalTeamDesc: 'Fundada por uma equipe diversificada com experiência em tecnologia de IA e produção multimídia, 微鲤AI está comprometida em fornecer experiências profissionais líderes do setor para sua jornada criativa.',
        
        innovativeTechTitle: 'Tecnologia Inovadora',
        innovativeTechDesc: 'Integrando os últimos avanços em tecnologia de IA, suportando acesso perfeito a vários modelos, incluindo Veo 3.1, Sora 2, Nano Banana, FLUX e mais, permitindo gerar facilmente vídeos, imagens e outros conteúdos de alta qualidade.',
        
        userCentricTitle: 'Centrado no Usuário',
        userCentricDesc: 'A plataforma se concentra na experiência do usuário, fornecendo uma interface intuitiva e fácil de usar com tela infinita, ajudando você a explorar espaço criativo ilimitado. Enquanto isso, nossa equipe de suporte dedicada está sempre pronta para ajudá-lo.',
        
        // Seção CTA
        ctaTitle: 'Junte-se a mais de 10 milhões de usuários criando e inspirando com 微鲤AI',
        ctaButton: 'Comece a Criar Agora',
    },
    it: {
        // Titolo della pagina
        pageTitle: 'Chi Siamo - 微鲤AI',
        
        // Sezione Hero
        subtitle: 'Pioniere nella Generazione di Video, Immagini e Umani Digitali con IA',
        description: '微鲤AI è una piattaforma di creazione di contenuti multimodali di nuova generazione. Che si tratti di immagini e video mozzafiato, umani digitali dinamici con personalità o tele infinite per realizzare idee folli, 微鲤AI sblocca possibilità creative illimitate alimentate dall\'IA.',
        
        // Sezione piattaforma
        platformTitle: 'Una Piattaforma, Possibilità Infinite',
        platformDescription: 'Dite addio al cambio frequente di strumenti. 微鲤AI fornisce generatori di immagini e video IA perfettamente integrati, modelli e strumenti avanzati, permettendovi di creare facilmente effetti visivi mozzafiato e liberare creatività massima.',
        
        // Perché sceglierci
        whyChooseTitle: 'Perché Scegliere 微鲤AI?',
        
        // Schede funzionalità
        professionalTeamTitle: 'Team Professionale',
        professionalTeamDesc: 'Fondata da un team diversificato con esperienza in tecnologia IA e produzione multimediale, 微鲤AI si impegna a fornire esperienze professionali leader del settore per il vostro viaggio creativo.',
        
        innovativeTechTitle: 'Tecnologia Innovativa',
        innovativeTechDesc: 'Integrando gli ultimi progressi della tecnologia IA, supportando l\'accesso senza soluzione di continuità a più modelli, inclusi Veo 3.1, Sora 2, Nano Banana, FLUX e altro, permettendovi di generare facilmente video, immagini e altri contenuti di alta qualità.',
        
        userCentricTitle: 'Centrato sull\'Utente',
        userCentricDesc: 'La piattaforma si concentra sull\'esperienza utente, fornendo un\'interfaccia intuitiva e facile da usare con tela infinita, aiutandovi a esplorare spazio creativo illimitato. Nel frattempo, il nostro team di supporto dedicato è sempre pronto ad assistervi.',
        
        // Sezione CTA
        ctaTitle: 'Unisciti a oltre 10 milioni di utenti che creano e si ispirano con 微鲤AI',
        ctaButton: 'Inizia a Creare Ora',
    },
    ar: {
        // عنوان الصفحة
        pageTitle: 'حول 微鲤AI',
        
        // قسم البطل
        subtitle: 'رائد في توليد الذكاء الاصطناعي للفيديو والصور والبشر الرقميين',
        description: '微鲤AI هي منصة إنشاء محتوى متعدد الوسائط من الجيل القادم. سواء كانت صور وفيديوهات مذهلة أو بشر رقميون ديناميكيون مع شخصية أو لوحات لا نهائية لتحقيق أفكار جامحة، فإن 微鲤AI تفتح إمكانيات إبداعية غير محدودة مدعومة بالذكاء الاصطناعي.',
        
        // قسم المنصة
        platformTitle: 'منصة واحدة، إمكانيات لا نهائية',
        platformDescription: 'قل وداعاً للتبديل المتكرر للأدوات. توفر 微鲤AI مولدات صور وفيديو بالذكاء الاصطناعي متكاملة بسلاسة ونماذج وأدوات متقدمة، مما يتيح لك إنشاء تأثيرات بصرية مذهلة بسهولة وإطلاق العنان للإبداع النهائي.',
        
        // لماذا تختارنا
        whyChooseTitle: 'لماذا تختار 微鲤AI؟',
        
        // بطاقات الميزات
        professionalTeamTitle: 'فريق محترف',
        professionalTeamDesc: 'أسسها فريق متنوع لديه خبرة في تكنولوجيا الذكاء الاصطناعي والإنتاج متعدد الوسائط، وتلتزم 微鲤AI بتوفير تجارب احترافية رائدة في الصناعة لرحلتك الإبداعية.',
        
        innovativeTechTitle: 'تكنولوجيا مبتكرة',
        innovativeTechDesc: 'دمج أحدث اختراقات تكنولوجيا الذكاء الاصطناعي، ودعم الوصول السلس إلى نماذج متعددة بما في ذلك Veo 3.1 و Sora 2 و Nano Banana و FLUX وغيرها، مما يتيح لك توليد مقاطع فيديو وصور ومحتوى آخر عالي الجودة بسهولة.',
        
        userCentricTitle: 'محوره المستخدم',
        userCentricDesc: 'تركز المنصة على تجربة المستخدم، وتوفر واجهة بديهية وسهلة الاستخدام مع لوحة لا نهائية، مما يساعدك على استكشاف مساحة إبداعية غير محدودة. في الوقت نفسه، فريق الدعم المخصص لدينا جاهز دائماً لمساعدتك.',
        
        // قسم الدعوة للعمل
        ctaTitle: 'انضم إلى أكثر من 10 ملايين مستخدم يبدعون ويلهمون مع 微鲤AI',
        ctaButton: 'ابدأ الإنشاء الآن',
        },
    th: {
        // Page title
        pageTitle: 'เกี่ยวกับ 微鲤AI',
        
        // Hero section
        subtitle: 'ผู้บุกเบิกการสร้างวิดีโอ ภาพ และมนุษย์ดิจิทัลด้วย AI',
        description: '微鲤AI คือแพลตฟอร์มสร้างสรรค์คอนเทนต์แบบมัลติโหมดรุ่นใหม่ ไม่ว่าจะเป็นภาพและวิดีโอสุดตระการตา มนุษย์ดิจิทัลที่มีบุคลิก หรือผืนผ้าใบไร้ขอบเขตเพื่อทำไอเดียสุดล้ำ 微鲤AI ปลดล็อกความเป็นไปได้ด้านความคิดสร้างสรรค์อย่างไร้ขีดจำกัดด้วยพลัง AI',
        
        // Platform section
        platformTitle: 'แพลตฟอร์มเดียว ความเป็นไปได้ไม่สิ้นสุด',
        platformDescription: 'บอกลาการสลับเครื่องมือบ่อยๆ 微鲤AI รวมเครื่องมือสร้างภาพและวิดีโอด้วย AI ไว้อย่างไร้รอยต่อ พร้อมโมเดลและเครื่องมือขั้นสูง ช่วยให้คุณสร้างเอฟเฟกต์ภาพอันน่าทึ่งได้ง่าย และปลดปล่อยความคิดสร้างสรรค์ขั้นสุด',
        
        // Why choose us
        whyChooseTitle: 'ทำไมต้องเลือก 微鲤AI?',
        
        // Feature cards
        professionalTeamTitle: 'ทีมมืออาชีพ',
        professionalTeamDesc: 'ก่อตั้งโดยทีมงานหลากหลายที่มีประสบการณ์ด้านเทคโนโลยี AI และการผลิตมัลติมีเดีย 微鲤AI มุ่งมั่นมอบประสบการณ์ระดับมืออาชีพชั้นนำให้กับเส้นทางสร้างสรรค์ของคุณ',
        
        innovativeTechTitle: 'เทคโนโลยีนวัตกรรม',
        innovativeTechDesc: 'ผสานความก้าวหน้าล่าสุดของเทคโนโลยี AI และรองรับการเข้าถึงหลายโมเดลอย่างไร้รอยต่อ เช่น Veo 3.1, Sora 2, Nano Banana, FLUX และอื่นๆ ช่วยให้คุณสร้างวิดีโอ ภาพ และคอนเทนต์คุณภาพสูงได้อย่างง่ายดาย',
        
        userCentricTitle: 'ยึดผู้ใช้เป็นศูนย์กลาง',
        userCentricDesc: 'แพลตฟอร์มให้ความสำคัญกับประสบการณ์ผู้ใช้ มีอินเทอร์เฟซที่ใช้งานง่ายพร้อมผืนผ้าใบไร้ขีดจำกัด ช่วยให้คุณสำรวจพื้นที่สร้างสรรค์ได้ไม่รู้จบ พร้อมทีมซัพพอร์ตที่พร้อมช่วยเหลือเสมอ',
        
        // CTA section
        ctaTitle: 'ร่วมกับผู้ใช้กว่า 10 ล้านคนที่กำลังสร้างสรรค์และได้แรงบันดาลใจจาก 微鲤AI',
        ctaButton: 'เริ่มสร้างสรรค์ตอนนี้',
        },
    da: {
        // Page title
        pageTitle: 'Om 微鲤AI',
        
        // Hero section
        subtitle: 'Pioner inden for AI‑video, billeder og digitale mennesker',
        description: '微鲤AI er en næste‑generations multimodal platform til indholdsskabelse. Uanset om det er imponerende billeder og videoer, dynamiske digitale mennesker med personlighed eller uendelige lærreder til vilde idéer, åbner 微鲤AI for ubegrænsede kreative muligheder drevet af AI.',
        
        // Platform section
        platformTitle: 'Én platform, uendelige muligheder',
        platformDescription: 'Sig farvel til konstant værktøjsskifte. 微鲤AI tilbyder sømløst integrerede AI‑billed- og videogeneratorer samt avancerede modeller og værktøjer, så du nemt kan skabe fantastiske visuelle effekter og frigøre maksimal kreativitet.',
        
        // Why choose us
        whyChooseTitle: 'Hvorfor vælge 微鲤AI?',
        
        // Feature cards
        professionalTeamTitle: 'Professionelt team',
        professionalTeamDesc: 'Grundlagt af et mangfoldigt team med erfaring inden for AI‑teknologi og multimediaproduktion. 微鲤AI er dedikeret til at levere branchens førende professionelle oplevelser til din kreative rejse.',
        
        innovativeTechTitle: 'Innovativ teknologi',
        innovativeTechDesc: 'Integrerer de nyeste AI‑gennembrud og understøtter problemfri adgang til flere modeller som Veo 3.1, Sora 2, Nano Banana, FLUX m.fl., så du let kan generere video, billeder og andet indhold i høj kvalitet.',
        
        userCentricTitle: 'Brugercentreret',
        userCentricDesc: 'Platformen sætter brugeroplevelsen i centrum med en intuitiv og let anvendelig grænseflade samt uendeligt lærred, der hjælper dig med at udforske ubegrænset kreativt rum. Samtidig står vores dedikerede supportteam klar til at hjælpe.',
        
        // CTA section
        ctaTitle: 'Slut dig til 10+ millioner brugere, der skaber og inspireres med 微鲤AI',
        ctaButton: 'Begynd at skabe nu',
        },
    no: {
        // Page title
        pageTitle: 'Om 微鲤AI',
        
        // Hero section
        subtitle: 'Pioner innen AI‑video, bilder og digitale mennesker',
        description: '微鲤AI er en neste generasjons multimodal plattform for innholdsskaping. Enten det er imponerende bilder og videoer, dynamiske digitale mennesker med personlighet eller uendelige lerreter for ville ideer, åpner 微鲤AI for ubegrensede kreative muligheter drevet av AI.',
        
        // Platform section
        platformTitle: 'Én plattform, uendelige muligheter',
        platformDescription: 'Si farvel til hyppig verktøybytte. 微鲤AI tilbyr sømløst integrerte AI‑bilde- og videogeneratorer, avanserte modeller og verktøy, slik at du enkelt kan skape fantastiske visuelle effekter og slippe løs maksimal kreativitet.',
        
        // Why choose us
        whyChooseTitle: 'Hvorfor velge 微鲤AI?',
        
        // Feature cards
        professionalTeamTitle: 'Profesjonelt team',
        professionalTeamDesc: 'Grunnlagt av et mangfoldig team med erfaring innen AI‑teknologi og multimediaproduksjon, er 微鲤AI dedikert til å gi bransjeledende profesjonelle opplevelser for din kreative reise.',
        
        innovativeTechTitle: 'Innovativ teknologi',
        innovativeTechDesc: 'Integrerer de nyeste AI‑gjennombruddene og støtter sømløs tilgang til flere modeller som Veo 3.1, Sora 2, Nano Banana, FLUX og mer, slik at du enkelt kan generere videoer, bilder og annet innhold av høy kvalitet.',
        
        userCentricTitle: 'Brukersentrert',
        userCentricDesc: 'Plattformen setter brukeropplevelsen i sentrum med et intuitivt og brukervennlig grensesnitt og uendelig lerret, som hjelper deg å utforske ubegrenset kreativt rom. Samtidig står vårt dedikerte supportteam klart til å hjelpe.',
        
        // CTA section
        ctaTitle: 'Bli med over 10 millioner brukere som skaper og blir inspirert med 微鲤AI',
        ctaButton: 'Begynn å skape nå',
        },
    nl: {
        // Page title
        pageTitle: 'Over 微鲤AI',
        
        // Hero section
        subtitle: 'Pionier in AI‑video, afbeeldingen en digitale mensen',
        description: '微鲤AI is een next‑gen multimodaal contentplatform. Of het nu gaat om verbluffende beelden en video’s, dynamische digitale mensen met persoonlijkheid of oneindige canvassen voor wilde ideeën, 微鲤AI ontsluit onbeperkte creatieve mogelijkheden met AI.',
        
        // Platform section
        platformTitle: 'Eén platform, eindeloze mogelijkheden',
        platformDescription: 'Zeg vaarwel tegen constant wisselen van tools. 微鲤AI biedt naadloos geïntegreerde AI‑beeld- en videogenerators, geavanceerde modellen en tools, zodat je eenvoudig indrukwekkende visuele effecten kunt maken en ultieme creativiteit kunt ontketenen.',
        
        // Why choose us
        whyChooseTitle: 'Waarom kiezen voor 微鲤AI?',
        
        // Feature cards
        professionalTeamTitle: 'Professioneel team',
        professionalTeamDesc: 'Opgericht door een divers team met ervaring in AI‑technologie en multimediaproductie. 微鲤AI zet zich in om toonaangevende professionele ervaringen te bieden voor jouw creatieve reis.',
        
        innovativeTechTitle: 'Innovatieve technologie',
        innovativeTechDesc: 'Integreert de nieuwste AI‑doorbraken en ondersteunt naadloze toegang tot meerdere modellen zoals Veo 3.1, Sora 2, Nano Banana, FLUX en meer, zodat je eenvoudig hoogwaardige video’s, afbeeldingen en andere content kunt genereren.',
        
        userCentricTitle: 'Gebruiker‑gericht',
        userCentricDesc: 'Het platform stelt de gebruikerservaring centraal met een intuïtieve, gebruiksvriendelijke interface en een oneindig canvas, zodat je onbeperkte creatieve ruimte kunt verkennen. Ondertussen staat ons supportteam altijd klaar om je te helpen.',
        
        // CTA section
        ctaTitle: 'Sluit je aan bij 10+ miljoen gebruikers die creëren en geïnspireerd raken met 微鲤AI',
        ctaButton: 'Begin nu met creëren',
        },
    id: {
        // Page title
        pageTitle: 'Tentang 微鲤AI',
        
        // Hero section
        subtitle: 'Pelopor AI untuk video, gambar, dan manusia digital',
        description: '微鲤AI adalah platform kreasi konten multimodal generasi terbaru. Baik gambar dan video yang memukau, manusia digital dinamis dengan kepribadian, maupun kanvas tanpa batas untuk mewujudkan ide liar, 微鲤AI membuka kemungkinan kreatif tak terbatas berkat AI.',
        
        // Platform section
        platformTitle: 'Satu platform, kemungkinan tanpa batas',
        platformDescription: 'Ucapkan selamat tinggal pada seringnya ganti alat. 微鲤AI menyediakan generator gambar dan video AI yang terintegrasi mulus, model dan tools canggih, memungkinkan Anda membuat efek visual menakjubkan dengan mudah dan melepas kreativitas sepenuhnya.',
        
        // Why choose us
        whyChooseTitle: 'Mengapa memilih 微鲤AI?',
        
        // Feature cards
        professionalTeamTitle: 'Tim profesional',
        professionalTeamDesc: 'Didirikan oleh tim beragam dengan pengalaman teknologi AI dan produksi multimedia, 微鲤AI berkomitmen memberikan pengalaman profesional terdepan untuk perjalanan kreatif Anda.',
        
        innovativeTechTitle: 'Teknologi inovatif',
        innovativeTechDesc: 'Mengintegrasikan terobosan AI terbaru, mendukung akses mulus ke banyak model termasuk Veo 3.1, Sora 2, Nano Banana, FLUX, dan lainnya, sehingga Anda dapat menghasilkan video, gambar, dan konten berkualitas tinggi dengan mudah.',
        
        userCentricTitle: 'Berpusat pada pengguna',
        userCentricDesc: 'Platform ini mengutamakan pengalaman pengguna dengan antarmuka intuitif dan mudah digunakan serta kanvas tanpa batas, membantu Anda menjelajahi ruang kreatif tak terbatas. Sementara itu, tim dukungan kami selalu siap membantu.',
        
        // CTA section
        ctaTitle: 'Bergabunglah dengan 10+ juta pengguna yang berkarya dan terinspirasi bersama 微鲤AI',
        ctaButton: 'Mulai berkarya sekarang',
        },
    tr: {
        // Page title
        pageTitle: '微鲤AI Hakkında',
        
        // Hero section
        subtitle: 'AI video, görsel ve dijital insan üretiminde öncü',
        description: '微鲤AI, yeni nesil çok modlu içerik üretim platformudur. İster etkileyici görseller ve videolar, ister kişiliğe sahip dinamik dijital insanlar, ister vahşi fikirleri hayata geçirmek için sonsuz tualler olsun; 微鲤AI, AI ile sınırsız yaratıcı olasılıkların kapısını açar.',
        
        // Platform section
        platformTitle: 'Tek platform, sonsuz olasılık',
        platformDescription: 'Sık sık araç değiştirmeye veda edin. 微鲤AI, kusursuz entegre AI görsel ve video üreticileri ile gelişmiş modeller ve araçlar sunar; böylece çarpıcı görsel efektleri kolayca oluşturabilir ve yaratıcılığınızı en üst düzeye çıkarabilirsiniz.',
        
        // Why choose us
        whyChooseTitle: 'Neden 微鲤AI?',
        
        // Feature cards
        professionalTeamTitle: 'Profesyonel ekip',
        professionalTeamDesc: 'AI teknolojisi ve multimedya üretimi deneyimine sahip, farklı uzmanlıklardan oluşan bir ekip tarafından kurulan 微鲤AI, yaratıcı yolculuğunuz için sektör lideri profesyonel deneyimler sunmayı taahhüt eder.',
        
        innovativeTechTitle: 'Yenilikçi teknoloji',
        innovativeTechDesc: 'En yeni AI atılımlarını entegre eder; Veo 3.1, Sora 2, Nano Banana, FLUX ve daha fazlası gibi birçok modele sorunsuz erişimi destekler. Böylece yüksek kaliteli video, görsel ve diğer içerikleri kolayca üretebilirsiniz.',
        
        userCentricTitle: 'Kullanıcı odaklı',
        userCentricDesc: 'Platform, sonsuz tuval ile sezgisel ve kullanımı kolay bir arayüz sunarak kullanıcı deneyimini merkeze alır ve sınırsız yaratıcı alanı keşfetmenize yardımcı olur. Ayrıca, özel destek ekibimiz her zaman yanınızdadır.',
        
        // CTA section
        ctaTitle: '微鲤AI ile üreten ve ilham alan 10+ milyon kullanıcıya katılın',
        ctaButton: 'Hemen oluşturmaya başlayın',
    },
}
